import { memo } from 'react'
import { useSelector } from 'react-redux';

const OptionMessage = ({ code, selector, ...props }) => {
  const options = useSelector(selector) ?? [];
  const option = options.find(op => op.value === code);
  return (
    <span {...props}>
      {option ? option.label : code}
    </span>
  )
}

export default memo(OptionMessage);